import React, { useRef } from 'react';
import { Download } from 'lucide-react';
import { PxWindow } from '../components/PixelUI';
import { NVLogo, NVAvatar, NVBanner, downloadSvgAsPng } from '../components/Brand';

const BrandKit = () => {
  const bannerRef = useRef(null);
  const avatarRef = useRef(null);
  const markRef = useRef(null);

  const grab = (ref) => ref.current?.querySelector('svg');

  return (
    <main className="nv-stars" style={{ minHeight: '85vh' }}>
      <section className="nv-section on-night" style={{ paddingTop: 40, position: 'relative', zIndex: 1 }}>
        <div className="nv-section-inner" style={{ maxWidth: 980 }}>
          <p className="nv-eyebrow">burned pixels, ready to ship</p>
          <h1 className="nv-h2" style={{ fontSize: 'clamp(26px, 5vw, 44px)' }} data-testid="brand-title">BRAND ROM</h1>
          <p style={{ color: 'var(--nv-tan)', maxWidth: 640, marginBottom: 36, lineHeight: 1.7 }}>
            The NANOVRAM mark, avatar tile and header banner — drawn in raw pixels, exported clean.
            No webfont in the banner ever, so the PNG always prints exactly what you see.
          </p>

          {/* banner */}
          <PxWindow title="BANNER · 1500 x 500" tape>
            <div ref={bannerRef} style={{ padding: 14, background: 'var(--nv-cream-2)' }} data-testid="banner-preview">
              <div style={{ border: '3px solid var(--nv-ink)' }}>
                <NVBanner />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12, padding: '0 14px 14px', background: 'var(--nv-cream-2)' }}>
              <button className="px-btn sm" onClick={() => downloadSvgAsPng(grab(bannerRef), 'nanovram-banner.png', 1500, 500)} data-testid="download-banner-btn">
                <Download size={13} /> PNG 1500x500
              </button>
            </div>
          </PxWindow>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 26, marginTop: 26 }}>
            {/* avatar */}
            <PxWindow title="AVATAR · SQUARE" tape>
              <div ref={avatarRef} style={{ padding: 20, display: 'flex', justifyContent: 'center', background: 'var(--nv-cream-2)' }} data-testid="avatar-preview">
                <div style={{ border: '3px solid var(--nv-ink)' }}>
                  <NVAvatar size={200} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: 12, padding: '0 14px 14px', justifyContent: 'center', background: 'var(--nv-cream-2)' }}>
                <button className="px-btn sm" onClick={() => downloadSvgAsPng(grab(avatarRef), 'nanovram-avatar.png', 640, 640)} data-testid="download-avatar-btn">
                  <Download size={13} /> PNG 640x640
                </button>
              </div>
            </PxWindow>

            {/* mark */}
            <PxWindow title="MARK · TRANSPARENT" tape>
              <div ref={markRef} style={{ padding: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'var(--nv-cream-2)', minHeight: 200 }} data-testid="mark-preview">
                <NVLogo size={140} />
              </div>
              <div style={{ display: 'flex', gap: 12, padding: '0 14px 14px', justifyContent: 'center', background: 'var(--nv-cream-2)' }}>
                <button className="px-btn sm" onClick={() => downloadSvgAsPng(grab(markRef), 'nanovram-mark.png', 560, 560)} data-testid="download-mark-btn">
                  <Download size={13} /> PNG 560x560
                </button>
              </div>
            </PxWindow>

            {/* palette */}
            <PxWindow title="PALETTE.CFG" tape>
              <div style={{ padding: 18 }}>
                {[['Night', '#211510'], ['Ground', '#8a5a33'], ['Cream', '#f7f0e1'], ['Gold', '#eac54f'], ['Teal spark', '#2f8f85'], ['Ink', '#2a1a0e']].map(([name, hex]) => (
                  <div key={hex} className="nv-kv" style={{ alignItems: 'center' }}>
                    <span className="k" style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ width: 18, height: 18, background: hex, border: '2px solid var(--nv-ink)', display: 'inline-block' }} />
                      {name}
                    </span>
                    <span className="v">{hex}</span>
                  </div>
                ))}
              </div>
            </PxWindow>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BrandKit;
